import { Check } from 'lucide-react';

/**
 * Branded post-checkout confirmation. Shows the gift amount + committee name.
 * This is the immediate in-page acknowledgement the donor sees on completion; a
 * separate branded receipt email is sent server-side when the donation's
 * payment_intent.succeeded event is ingested (best-effort, post-commit).
 */
export function DonationThankYou({
  committeeName,
  amount,
}: {
  committeeName: string;
  amount: number;
}) {
  const formattedAmount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);

  return (
    <div className="donation-thank-you">
      <div className="donation-success-mark"><Check aria-hidden="true" /></div>
      <p className="donation-eyebrow">Contribution received</p>
      <h1>Thank you!</h1>
      <p>
        Your gift of{' '}
        <span className="font-semibold">{formattedAmount}</span> to{' '}
        <span className="font-semibold">{committeeName}</span> was received.
      </p>
      <p className="donation-receipt-note">A receipt will arrive by email shortly.</p>
    </div>
  );
}
